import { TakerOrMaker, Trade } from "@cede/types";
import { randomId } from "../random";

export class TradeFactory {
  private trades: Trade[] = [];

  create({ amount, price }: Partial<Trade> = {}) {
    this.trades.push({
      id: randomId(),
      amount: amount ?? 1,
      price: price ?? 1,
      timestamp: new Date().getTime(),
      pairSymbol: "",
      side: "buy",
      takerOrMaker: TakerOrMaker.MAKER,
      fee: {
        amount: 0,
        refAmount: undefined,
        tokenSymbol: "",
      },
    });
    return this;
  }

  getAll() {
    return this.trades;
  }
}
